import MasterCard from '../Icons/MasterCard';
import Visa from '../Icons/Visa';
import Amex from '../Icons/Amex';
import UnionPay from '../Icons/UnionPay';
import { useDonationStore } from '../libs/useDonationStore';
import { CREDIT_CARD_PROVIDER, PAYMENT_TYPE } from '../libs/common';
import type { FC } from 'react';

const CheckoutPaymentIcons: FC = () => {
    const { donationData } = useDonationStore();

    if (donationData.payment === PAYMENT_TYPE.DIRECT_DEBIT) {
        return null;
    }

    return (
        <div className="donation-payment-icons-group">
            <div className="donation-payment-icon-item">
                <MasterCard />
            </div>
            <div className="donation-payment-icon-item">
                <Visa />
            </div>
            <div className="donation-payment-icon-item">
                <Amex />
            </div>
            {donationData.payment === CREDIT_CARD_PROVIDER.IPG && (
                <div className="donation-payment-icon-item">
                    <UnionPay />
                </div>
            )}
        </div>
    );
};

export default CheckoutPaymentIcons;
